//Modules
import React from "react"
import { documentToReactComponents } from "@contentful/rich-text-react-renderer"
//Styles
import { flex, font, spacing, grays, boxShadow } from "../../Utilities"
import styled from "styled-components"

const Section = ({ section }) => {
  const {
    name,
    body: { json },
  } = section

  const options = {
    renderNode: {
      "embedded-asset-block": node => {
        const url = node.data.target.fields.file["en-US"].url
        const alt = node.data.target.fields.title["en-US"]
        const description = node.data.target.fields.description

        const width = node.data.target.fields.file["en-US"].details.image.width

        return (
          <StyledEmbed href={url} target="_blank">
            <img
              src={url}
              alt={alt}
              className={width <= 200 ? "narrow-image" : null}
            />
            {description && (
              <p className="image-caption">{description["en-US"]}</p>
            )}
          </StyledEmbed>
        )
      },
    },
  }

  return (
    <StyledSection>
      <h2 className="title">{name}</h2>
      <div className="rich-text">
        {documentToReactComponents(json, options)}
      </div>
    </StyledSection>
  )
}

const StyledSection = styled.article`
  ${flex("column", "flex-start", "center")};
  max-width: 80rem;

  .title {
    ${font("M")};
    margin-bottom: ${spacing.SM};
  }

  .rich-text {
    ${flex("column", "flex-start", "center")};

    p,
    h3 {
      margin-bottom: ${spacing.S};
    }

    h3 {
      ${font("SM")};
    }

    p {
      ${font("S")};

      a {
        color: dodgerblue;
      }
    }
  }
`

const StyledEmbed = styled.a`
  ${flex("column", "flex-start", "center")};
  width: 100%;
  margin: ${spacing.M} 0;

  img {
    width: 100%;
    object-fit: contain;
    box-shadow: ${boxShadow.dark};
    border-radius: 5px;
    max-width: 60rem;
    margin-bottom: ${spacing.S};
  }

  .narrow-image {
    max-width: 22rem;
  }

  .image-caption {
    text-align: center;
    color: ${grays[4]};
  }
`

export default Section
